import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  MicrosoftTeamsCallQueuesFieldConfig,
  MicrosoftTeamsUserCallQueuesMembership,
} from '../models/generated/ziroModels';

@Injectable()
export class TeamsCallQueueMembershipResource {
  protected http = inject(HttpClient);

  getQueueMemberships(tenantId: string): Observable<MicrosoftTeamsCallQueuesFieldConfig> {
    return this.http.get<MicrosoftTeamsCallQueuesFieldConfig>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/field-configs/queue-memberships`,
    );
  }

  getUserQueueMemberships(upn: string, tenantId: string): Observable<MicrosoftTeamsUserCallQueuesMembership> {
    return this.http.get<MicrosoftTeamsUserCallQueuesMembership>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/queue-memberships/${upn}`,
    );
  }

  saveUserQueueMemberships(
    upn: string,
    queues: MicrosoftTeamsUserCallQueuesMembership,
    tenantId: string,
  ): Observable<void> {
    return this.http.put<void>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/queue-memberships/${upn}`,
      queues,
    );
  }

  removeUserQueueMemberships(upn: string, tenantId: string): Observable<void> {
    return this.saveUserQueueMemberships(upn, { userPrincipalName: upn, callQueueJsons: [] }, tenantId);
  }
}
